import { Routes, Route, Navigate } from "react-router-dom";

import { Shell } from "@/components/Shell";
import { ToastProvider } from "@/components/ui/Toast";
import { ConfirmProvider } from "@/components/ui/Confirm";

import { Handoff } from "@/routes/Handoff";
import { Home } from "@/routes/Home";
import { Gaps } from "@/routes/Gaps";
import { Conversations } from "@/routes/Conversations";
import { Tickets } from "@/routes/Tickets";
import { Knowledge } from "@/routes/Knowledge";
import { Bot } from "@/routes/Settings/Bot";
import { Domains } from "@/routes/Settings/Domains";
import { Widget } from "@/routes/Settings/Widget";

export default function App() {
  return (
    <ToastProvider>
      <ConfirmProvider>
        <Routes>
        <Route path="/handoff" element={<Handoff />} />
        <Route element={<Shell />}>
          <Route path="/" element={<Home />} />
          <Route path="/gaps" element={<Gaps />} />
          <Route path="/conversations" element={<Conversations />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/knowledge" element={<Knowledge />} />
          <Route path="/settings/bot" element={<Bot />} />
          <Route path="/settings/widget" element={<Widget />} />
          <Route path="/settings/domains" element={<Domains />} />
        </Route>
        {/* Unknown paths fall back to Home instead of rendering blank. The
            Vercel rewrite already serves index.html for every path, so this
            handles client-side navigation to a stale/typo'd route. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ConfirmProvider>
    </ToastProvider>
  );
}
